import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Card, CardBody, CardFooter,Row, Col, Progress, Table, Badge,Nav,NavItem, TabContent,TabPane,NavLink} from "reactstrap";
import {Bar, Line} from "react-chartjs-2";
import classNames from 'classnames';
import {mapToCssModules} from 'reactstrap/lib/utils';
import classnames from "classnames";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';


const propTypes = {
    graphingArray : PropTypes.array,
    graphingAvg : PropTypes.number

};

const defaultProps = {
    header: '$1,999.50',
    mainText: 'Income',
    icon: "fa fa-cogs",
    color: 'primary',
    variant: "0",
    link: "#",
    Voltage:4160,
    graphingAvg : 0


};

// Card Chart 1


class SystemCharts extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: '1'
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }


    render() {

        const {Voltage,
            graphingAvg,
            graphingArray,
            className, cssModule, header, mainText, icon, color, footer, link, children, variant, ...attributes} = this.props;

        // demo purposes only
        const padding = (variant === '0' ? {card: "p-3", icon: "p-3", lead: "mt-2"} : ( variant === "1" ? {
            card: "p-0", icon: "p-4", lead: "pt-3" } : {card: "p-0", icon: "p-4 px-5", lead: "pt-3"}));

        const card = {style: "card-body clearfix", color: color, icon: icon, classes: ""};
        card.classes = mapToCssModules(classNames(className, card.style, padding.card), cssModule);

        const lead = {style: "h5 mb-0", color: color, classes: ""};
        lead.classes = classNames(lead.style, 'text-' + card.color, padding.lead);

        const blockIcon = function (icon) {
            const classes = classNames(icon, 'bg-' + card.color, padding.icon, "font-2xl mr-3 float-left");
            return (<i className={ classes }></i>);
        };

        let cardChartData1 = {
            labels: ['1', '2', '3', '4', '5', '6', '7'],
            datasets: [
                {
                    label: 'Sys Voltage',
                    backgroundColor: 'rgba(255, 77, 79, 0.1)',
                    borderColor: 'rgba(255, 77, 79, 0.85)',
                    data: graphingArray
                }
            ],
        };
        let cardChartOpts1 = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        color: 'transparent',
                        zeroLineColor: 'transparent'
                    },
                    ticks: {
                        fontSize: 2,
                        fontColor: 'transparent',
                    }
                }],
                yAxes: [{
                    display: false,
                    ticks: {
                        display: false,
                        min: Math.min.apply(Math, cardChartData1.datasets[0].data) - 5,
                        max: Math.max.apply(Math, cardChartData1.datasets[0].data) + 5,
                    }
                }],
            },
            elements: {
                line: {
                    borderWidth: 2
                },
                point: {
                    radius: 4,
                    hitRadius: 10,
                    hoverRadius: 4,
                },
            }
        };


        const cardChartOpts3 = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    display: false
                }],
                yAxes: [{
                    display: false
                }],
            },
            elements: {
                line: {
                    borderWidth: 2
                },
                point: {
                    radius: 2,
                    hitRadius: 10,
                    hoverRadius: 4,
                },
            }
        };
        const cardChartOpts4 = {
            maintainAspectRatio: false,
            legend: {
                display: false
            },
            scales: {
                xAxes: [{
                    display: false,
                    barPercentage: 0.6,
                }],
                yAxes: [{
                    display: false,
                }]
            }
        };

        return (
            <Card className="text-black-50 bg-white">
                <CardBody className="card-body pb-0">
                    <h4 className="mb-0">{graphingAvg}</h4>
                    <p>{header}</p>
                </CardBody>
                <div className="chart-wrapper px-0" style={{height:'70px'}}>
                    <Line data={cardChartData1} options={cardChartOpts3} height={70} redraw/>
                </div>
            </Card>
        )
    }
}
SystemCharts.propTypes = propTypes;
SystemCharts.defaultProps = defaultProps;
export default SystemCharts;


// WEBPACK FOOTER //
// ./src/views/site/SystemSchema/SystemCharts.js